import React, { useState, useEffect } from "react";
import Board from "./board.tsx";
import Square from "./square.tsx";
import styles from "./ticTacToe.module.scss";
import db from "../../firebase_setup/firebase.js";

const defaultSquares = () => new Array(9).fill(null);

const lines = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
];

export default function TicTacToe(props) {
  const [squares, setSquares] = useState(defaultSquares());
  const [winner, setWinner] = useState("");
  const [winnerIndexes, setWinnerIndexes] = useState<number[]>([]);

  const [rapolasWinsCount, setRapolasWinsCount] = useState(props.rapolasWins);
  const [visitorWinsCount, setVisitorWinsCount] = useState(props.visitorsWins);

  const updateRapolasWinsData = async () => {
    await db
      .collection("visitorCount")
      .doc("winsCount")
      .update({ RapolasWinsCount: rapolasWinsCount + 1 });
  };
  const updateVisitorWinsData = async () => {
    if (props.dataReceived) {
      await db
        .collection("visitorCount")
        .doc("winsCount")
        .update({ visitorWinsCount: visitorWinsCount + 1 });
    }
  };

  //

  //method to check line symbols x,o
  const linesThatAre = (a: string, b: string, c: string) => {
    return lines.filter((squareIndexes) => {
      const squareValues = squareIndexes.map((index) => squares[index]);
      return (
        JSON.stringify([a, b, c].sort()) ===
        JSON.stringify(squareValues.sort(), squareIndexes)
      );
    });
  };

  useEffect(() => {
    const emptyIndexes = squares
      .map((square, index: number) => (square === null ? index : null))
      .filter((val) => val !== null);
    if (emptyIndexes.length === 0) {
      setWinner("draw");
    }
    const isComputerTurn =
      squares.filter((square) => square !== null).length % 2 === 1;
    const putComputerAt = (index: number) => {
      let newSquares = squares;
      newSquares[index] = "o";
      setSquares([...newSquares]);
    };

    if (isComputerTurn && !!!winner) {
      const winingLines = linesThatAre("o", "o", null);
      //winning move
      if (winingLines.length > 0) {
        const winIndex = winingLines[0].filter(
          (index) => squares[index] === null
        )[0];
        putComputerAt(winIndex);
        setWinnerIndexes(linesThatAre("o", "o", "o")[0]);
        updateRapolasWinsData();
        setRapolasWinsCount(rapolasWinsCount + 1);
        return setWinner("o");
      }

      //if center is empty, playing there
      if (!!!squares[4]) {
        putComputerAt(4);
        return;
      }

      const linesToBlock = linesThatAre("x", "x", null);
      // blocking visitor win
      if (linesToBlock.length > 0) {
        const blockIndex = linesToBlock[0].filter(
          (index) => squares[index] === null
        )[0];
        putComputerAt(blockIndex);
        return;
      }

      const linesToContinue = linesThatAre("o", null, null);
      //getting closer to win
      if (linesToContinue.length > 0) {
        putComputerAt(
          linesToContinue[0].filter((index) => squares[index] === null)[0]
        );
        return;
      }

      //random move
      const randomIndex =
        emptyIndexes[Math.ceil(Math.random() * emptyIndexes.length)];
      putComputerAt(randomIndex);
    }
  }, [squares]);

  function handleNewGame() {
    setSquares(defaultSquares());
    setWinnerIndexes([]);
    setWinner("");
  }

  function handleSquareClick(index: number) {
    const isPlayerTurn =
      squares.filter((square) => square !== null).length % 2 === 0;
    if (isPlayerTurn && squares[index] !== "o" && !!!winner) {
      let newSqures = squares;
      newSqures[index] = "x";
      setSquares([...newSqures]);

      if (linesThatAre("x", "x", "x").length > 0) {
        setWinnerIndexes(linesThatAre("x", "x", "x")[0]);
        setWinner("x");
        updateVisitorWinsData();
        setVisitorWinsCount(visitorWinsCount + 1);
      }
    }
  }
  const findSquareStyle = (square: string, index: number) => {
    let style = "";
    if (square === null && !!!winner) {
      return "emptySquare";
    } else if (!!winnerIndexes && !!winner) {
      winnerIndexes.forEach((element: number) => {
        if (index === element) {
          style = "winnerSquare";
        }
      });
    }
    return style;
  };

  return (
    <>
      <div className={styles.pageLayout}>
        <div className={styles.information}>
          <div className={styles.message}>Got bored? let's play a game!</div>
          <div className={styles.statsHeader}>
            Scoreboard:
            <div className={styles.stats}>
              <span className={styles.cpu}>
                Rapolas:{" "}
                <span className={styles.score}>{rapolasWinsCount}</span>
              </span>
              <span className={styles.humanWins}>
                Visitors:{" "}
                <span className={styles.score}>{visitorWinsCount}</span>
              </span>
            </div>
          </div>
          {!winner && <div className={styles.result}>Good luck!</div>}
          {!!winner && winner === "x" && (
            <div className={styles.result}>
              You won!
              <span className={styles.retryButton} onClick={handleNewGame}>
                Retry
              </span>
            </div>
          )}
          {!!winner && winner === "o" && (
            <div className={styles.result}>
              You lost!{" "}
              <span className={styles.retryButton} onClick={handleNewGame}>
                Retry
              </span>
            </div>
          )}
          {!!winner && winner === "draw" && (
            <div className={styles.result}>
              It's a draw!{" "}
              <span className={styles.retryButton} onClick={handleNewGame}>
                Retry
              </span>
            </div>
          )}
        </div>
        <div className={styles.game}>
          <Board>
            {squares.map((square, index: number) => (
              <Square
                key={index}
                x={square === "x" ? 1 : 0}
                o={square === "o" ? 1 : 0}
                styles={findSquareStyle(square, index)}
                onClick={() => handleSquareClick(index)}
              />
            ))}
          </Board>
        </div>
      </div>
    </>
  );
}
